/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitInsuranceMatchRequest
 */
export interface MonitInsuranceMatchRequest {
    /**
     * 
     * @type {string}
     * @memberof MonitInsuranceMatchRequest
     */
    policy_number: string;
    /**
     * 
     * @type {string}
     * @memberof MonitInsuranceMatchRequest
     */
    policy_uuid: string;
    /**
     * 
     * @type {string}
     * @memberof MonitInsuranceMatchRequest
     */
    account_line_uuid: string;
}

/**
 * Check if a given object implements the MonitInsuranceMatchRequest interface.
 */
export function instanceOfMonitInsuranceMatchRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "policy_number" in value;
    isInstance = isInstance && "policy_uuid" in value;
    isInstance = isInstance && "account_line_uuid" in value;

    return isInstance;
}

export function MonitInsuranceMatchRequestFromJSON(json: any): MonitInsuranceMatchRequest {
    return MonitInsuranceMatchRequestFromJSONTyped(json, false);
}

export function MonitInsuranceMatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitInsuranceMatchRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'policy_number': json['policy_number'],
        'policy_uuid': json['policy_uuid'],
        'account_line_uuid': json['account_line_uuid'],
    };
}

export function MonitInsuranceMatchRequestToJSON(value?: MonitInsuranceMatchRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'policy_number': value.policy_number,
        'policy_uuid': value.policy_uuid,
        'account_line_uuid': value.account_line_uuid,
    };
}

